module.exports = __webpack_public_path__ + "static/media/cross.1004371a.svg";